export default {
  namespaced: true,
  actions: {
    create({ commit }, studyRight) {
      this.$authorize('edit', 'Profile')

      return Vue.$http.post('admin/study_rights', { studyRight })
    },
    destroy({ commit }, id) {
      this.$authorize('edit', 'Profile')

      return Vue.$http.delete(`admin/study_rights/${id}`)
    }
  }
}
